module.exports = __webpack_public_path__ + "static/media/image_part_004.7284d7ac.jpg";